module.exports = __webpack_public_path__ + "img/sea-small.17573822.jpg";